import { render, staticRenderFns } from "./productUi.vue?vue&type=template&id=673a8660"
import script from "./productUi.vue?vue&type=script&lang=js"
export * from "./productUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports